import PublicLayout from "@/components/PublicLayout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { STATUS_LABEL, STATUS_BADGE, PAYMENT_BADGE } from "@/lib/statusLabels";
import StatusTimeline from "@/components/StatusTimeline";

export default function TrackOrder() {
  const [orderNumber, setOrderNumber] = useState("");
  const [email, setEmail] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);
    try {
      const { data } = await api.post("/track-order", {
        order_number: orderNumber.trim().toUpperCase(),
        email: email.trim().toLowerCase(),
      });
      setResult(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Order not found");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PublicLayout>
      <section className="gradient-radial-blue">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="section-label">Track Order</div>
          <h1 className="mt-2 font-display font-bold text-4xl sm:text-5xl text-[#0A192F]">Where&apos;s my filing?</h1>
          <p className="mt-3 text-slate-600">Enter your order number and the email used at checkout.</p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <form onSubmit={submit} className="rounded-xl border border-slate-200 bg-white p-6 grid sm:grid-cols-3 gap-4" data-testid="track-form">
            <div className="sm:col-span-1">
              <Label>Order Number</Label>
              <Input placeholder="W2E-1001" required value={orderNumber} onChange={(e) => setOrderNumber(e.target.value)} data-testid="track-order-number" />
            </div>
            <div className="sm:col-span-1">
              <Label>Email</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="track-email" />
            </div>
            <div className="sm:col-span-1 flex items-end">
              <Button type="submit" disabled={loading} className="w-full bg-[#1E3A8A] hover:bg-[#1E40AF]" data-testid="track-submit-btn">
                {loading ? "Searching…" : "Track Order"}
              </Button>
            </div>
          </form>

          {result && (
            <div className="mt-8 rounded-xl border border-slate-200 bg-white p-6" data-testid="track-result">
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <div className="section-label">Order</div>
                  <div className="font-display font-bold text-2xl text-[#0A192F] font-mono">{result.order.order_number}</div>
                  <div className="text-slate-600 text-sm mt-1">{result.order.service_name}</div>
                </div>
                <div className="flex flex-col gap-1.5 items-end">
                  <span className={`status-badge ${PAYMENT_BADGE[result.order.payment_status] || "badge-muted"}`}>Payment: {result.order.payment_status}</span>
                  <span className={`status-badge ${STATUS_BADGE[result.order.current_status] || "badge-muted"}`}>
                    {STATUS_LABEL[result.order.current_status] || result.order.current_status}
                  </span>
                </div>
              </div>

              <div className="mt-6">
                <StatusTimeline current={result.order.current_status} />
              </div>
            </div>
          )}
        </div>
      </section>
    </PublicLayout>
  );
}
